<template>
    <picture class="block w-16">
        <img src="@/assets/logo.png" alt="El zen de Python" class="w-full">
    </picture>
</template>

<script>
export default {
    
    name: "Logo"

}
</script>